module.exports = __webpack_public_path__ + "static/media/88-lotto-square.4d2baffe.png";